import { conditionalRender } from '@repo/toolkit/conditional-render'
import { toFullName } from '@repo/toolkit/to-full-name'
import SelectInput from '@repo/ui/select-input'
import { useMutation, useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'

import { assignEnrollmentsToAdviser } from '../../../../api/enrollments/assign-enrollments-to-adviser'
import { getAdvisors } from '../../../../api/enrollments/get-advisors'
import { User } from '../../../../lib/types/models/users/user'
import { showAxiosError } from '../../../../lib/utils/functions/misc.functions'

type Props = {
  enrollmentId: number
  attributedUser?: Pick<User, 'id' | 'firstName' | 'lastName'>
}

const EnrollmentAdvisorsSelection = ({ enrollmentId, attributedUser }: Props) => {
  const { data: advisors } = useQuery({
    queryKey: ['advisors'],
    queryFn: getAdvisors
  })

  // attributed user first and last name
  const au = advisors?.find((a) => a.id === attributedUser?.id)
  const attributedUserName = toFullName(au?.firstName, au?.lastName)

  const {
    mutate: assignEnrollmentsToAdviserMutation,
    isPending: isAssignEnrollmentsToAdviserPending
  } = useMutation({
    mutationFn: assignEnrollmentsToAdviser,
    onError: showAxiosError,
    onSuccess: () => toast.success('Conseiller LEC attribué')
  })

  if (!advisors) return null

  return (
    <SelectInput
      className={'w-52'}
      label={'Conseiller LEC'}
      searchable
      options={advisors?.map((advisor) => ({
        label: toFullName(advisor.firstName, advisor.lastName),
        value: advisor.id
      }))}
      selectedOption={conditionalRender(!!attributedUser, {
        value: attributedUser?.id,
        label: attributedUserName
      })}
      onChange={(id) => {
        if (id) assignEnrollmentsToAdviserMutation({ ids: [enrollmentId], id: Number(id) })
      }}
      disabled={isAssignEnrollmentsToAdviserPending}
    />
  )
}

export default EnrollmentAdvisorsSelection
